import React from 'react'
import AppProvider from './src/context/App/Provider.js'

export const wrapRootElement = ({ element }) => (
  <AppProvider>{element}</AppProvider>
)
